import { useMutation } from '@provision/graphql-client';
import { SAVE_LANDING_PAGE_CONFIG_MUTATION } from 'src/graphql/entities/landing-page-config/landing-page-config.operations';
import type {
  SaveLandingPageConfigMutationData,
  SaveLandingPageConfigMutationVariables,
} from 'src/graphql/entities/landing-page-config/landing-page-config.types';

export const useSaveLandingPageConfig = () => {
  const [saveLandingPageConfig, { data, loading, error }] = useMutation<
    SaveLandingPageConfigMutationData,
    SaveLandingPageConfigMutationVariables
  >(SAVE_LANDING_PAGE_CONFIG_MUTATION);

  return { saveLandingPageConfig, data, loading, error };
};
